// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2Bs5Q","list":"PatternAutocomplete_list__322jc"};